<template>
    <div class="full whiteBg">
        <iframe :src="src"/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            src: '',
        };
    },
    created() {
        this.src = window.atob(this.$route.params.src);
    },
};
</script>

<style scoped>
iframe {
    width: 100%;
    height: 100%;
    border: none;
}

.whiteBg{
    background-color: white;
}
</style>